import React, { useState } from "react";
import { Link } from "react-router-dom";

/* ── data ── */
const PLANS = [
  {
    id: "basic",
    name: "Voyageur",
    price: "Gratuit",
    priceNote: "pour toujours",
    color: "#f4f4f0",
    accent: "#1a1a1a",
    features: [
      { label: "Recherche de trajets",       ok: true },
      { label: "Réservation en ligne",       ok: true },
      { label: "Billet numérique",           ok: true },
      { label: "1 billet actif à la fois",   ok: true },
      { label: "Support par email",          ok: true },
      { label: "Annulation gratuite 24h",    ok: false },
      { label: "Historique illimité",        ok: false },
      { label: "Alertes de prix",            ok: false },
      { label: "Accès prioritaire",          ok: false },
    ],
    cta: "Commencer",
    ctaStyle: "outline",
  },
  {
    id: "pro",
    name: "Premium",
    price: "9 900",
    priceNote: "MGA / mois",
    color: "#1a1a1a",
    accent: "#4ade80",
    popular: true,
    features: [
      { label: "Recherche de trajets",       ok: true },
      { label: "Réservation en ligne",       ok: true },
      { label: "Billet numérique",           ok: true },
      { label: "Billets illimités",          ok: true },
      { label: "Support prioritaire 24/7",   ok: true },
      { label: "Annulation gratuite 24h",    ok: true },
      { label: "Historique illimité",        ok: true },
      { label: "Alertes de prix",            ok: true },
      { label: "Accès prioritaire",          ok: false },
    ],
    cta: "Commencer 14j gratuits",
    ctaStyle: "primary",
  },
  {
    id: "business",
    name: "Entreprise",
    price: "Sur devis",
    priceNote: "pour votre équipe",
    color: "#fafaf8",
    accent: "#1a1a1a",
    features: [
      { label: "Tout du plan Premium",       ok: true },
      { label: "Multi-comptes équipe",       ok: true },
      { label: "Facturation centralisée",    ok: true },
      { label: "Rapports de déplacements",   ok: true },
      { label: "Support dédié",             ok: true },
      { label: "Annulation gratuite 24h",    ok: true },
      { label: "Historique illimité",        ok: true },
      { label: "Alertes de prix",            ok: true },
      { label: "Accès prioritaire boarding", ok: true },
    ],
    cta: "Nous contacter",
    ctaStyle: "outline",
  },
];

const FARE_TABLE = [
  { route: "Antananarivo → Toamasina",       bus: "38 000",  taxib: "32 000", cov: "25 000", km: 370 },
  { route: "Antananarivo → Fianarantsoa",    bus: "45 000",  taxib: "40 000", cov: "30 000", km: 403 },
  { route: "Antananarivo → Mahajanga",       bus: "70 000",  taxib: "62 000", cov: "50 000", km: 571 },
  { route: "Antananarivo → Antsirabe",       bus: "20 000",  taxib: "17 000", cov: "12 000", km: 170 },
  { route: "Antananarivo → Ambositra",       bus: "28 000",  taxib: "24 000", cov: "18 000", km: 252 },
  { route: "Antananarivo → Moramanga",       bus: "15 000",  taxib: "13 000", cov: "9 000",  km: 113 },
  { route: "Fianarantsoa → Toliara",         bus: "80 000",  taxib: "72 000", cov: "55 000", km: 643 },
  { route: "Toamasina → Fénérive-Est",       bus: "22 000",  taxib: "18 000", cov: "14 000", km: 180 },
  { route: "Mahajanga → Antsiranana",        bus: "90 000",  taxib: "80 000", cov: "65 000", km: 692 },
];

const FAQS = [
  { q: "Les prix sont-ils fixes ?",          a: "Les tarifs affichés sont les prix de référence. Ils peuvent varier légèrement selon la saison, le transporteur et la disponibilité." },
  { q: "Comment payer ?",                    a: "Nous acceptons Mobile Money (MVola, Orange Money, Airtel Money), carte bancaire Visa/Mastercard, et paiement en espèces au guichet." },
  { q: "Peut-on annuler une réservation ?",  a: "Oui. Annulation gratuite jusqu'à 24h avant le départ pour les membres Premium. Pour les autres, des frais de 10% s'appliquent." },
  { q: "Y a-t-il des réductions ?",         a: "Oui : −50% pour les enfants de moins de 5 ans, −25% pour les enfants de 5 à 12 ans, −15% pour les groupes de 5 personnes ou plus." },
  { q: "Le billet est-il nominatif ?",      a: "Oui, le billet est nominatif et non-transférable. Présentez une pièce d'identité lors du départ." },
];

/* ── components ── */
const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <header style={s.header}>
      <Link to="/" style={s.logo}>Trans<span style={{ color: "#16a34a" }}>TiGo</span></Link>

      <nav style={s.nav} className="desktop-nav">
        <Link to="/destinations" style={s.navLink}>Destinations</Link>
        <Link to="/covoiturage"  style={s.navLink}>Covoiturage</Link>
        <Link to="/tarifs"       style={{ ...s.navLink, color: "#1a1a1a", fontWeight: 600 }}>Tarifs</Link>
        <Link to="/contact"      style={s.navLink}>Contact</Link>
      </nav>
      <div style={{ display: "flex", gap: 10 }} className="desktop-nav">
        <Link to="/login"    style={s.btnGhost}>Connexion</Link>
        <Link to="/register" style={s.btnPrimary}>S'inscrire</Link>
      </div>

      <button
        className="hamburger"
        style={s.hamburger}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Menu"
      >
        <span style={{ ...s.hamburgerBar, transform: menuOpen ? "rotate(45deg) translate(5px, 5px)" : "none" }} />
        <span style={{ ...s.hamburgerBar, opacity: menuOpen ? 0 : 1 }} />
        <span style={{ ...s.hamburgerBar, transform: menuOpen ? "rotate(-45deg) translate(5px, -5px)" : "none" }} />
      </button>

      {menuOpen && (
        <div style={s.mobileMenu}>
          {[
            ["Destinations", "/destinations"],
            ["Covoiturage", "/covoiturage"],
            ["Tarifs", "/tarifs"],
            ["Contact", "/contact"],
          ].map(([label, to]) => (
            <Link key={label} to={to} style={s.mobileNavLink} onClick={() => setMenuOpen(false)}>{label}</Link>
          ))}
          <div style={{ display: "flex", gap: 8, padding: "12px 0 4px" }}>
            <Link to="/login"    style={{ ...s.btnGhost, flex: 1, textAlign: "center" }}>Connexion</Link>
            <Link to="/register" style={{ ...s.btnPrimary, flex: 1, textAlign: "center" }}>S'inscrire</Link>
          </div>
        </div>
      )}
    </header>
  );
};

const PlanCard = ({ plan }) => (
  <div style={{ ...s.planCard, background: plan.color, border: plan.popular ? `2px solid ${plan.accent}` : "0.5px solid #e8e8e4" }}>
    {plan.popular && (
      <div style={{ ...s.popularBadge, background: plan.accent, color: "#1a1a1a" }}>Le plus populaire</div>
    )}
    <div style={s.planHeader}>
      <div style={{ ...s.planName, color: plan.popular ? "white" : "#1a1a1a" }}>{plan.name}</div>
      <div style={s.planPriceRow}>
        <span style={{ ...s.planPrice, color: plan.popular ? "white" : "#1a1a1a" }}>{plan.price}</span>
        {plan.price !== "Sur devis" && (
          <span style={{ ...s.planPriceNote, color: plan.popular ? "rgba(255,255,255,0.5)" : "#999" }}>{plan.priceNote}</span>
        )}
      </div>
      {plan.price === "Sur devis" && (
        <span style={{ ...s.planPriceNote, color: "#999" }}>{plan.priceNote}</span>
      )}
    </div>
    <div style={s.featureList}>
      {plan.features.map(f => (
        <div key={f.label} style={s.featureRow}>
          <span style={{ fontSize: 13, color: f.ok ? plan.accent : (plan.popular ? "rgba(255,255,255,0.2)" : "#e0e0e0"), flexShrink: 0 }}>
            {f.ok ? "✓" : "×"}
          </span>
          <span style={{ fontSize: 13, color: f.ok ? (plan.popular ? "rgba(255,255,255,0.85)" : "#444") : (plan.popular ? "rgba(255,255,255,0.3)" : "#bbb") }}>
            {f.label}
          </span>
        </div>
      ))}
    </div>
    <Link
      to={plan.id === "business" ? "/contact" : "/contact"}
      style={{
        ...s.planCta,
        background: plan.ctaStyle === "primary" ? plan.accent : "transparent",
        color: plan.ctaStyle === "primary" ? "#1a1a1a" : (plan.popular ? "white" : "#1a1a1a"),
        border: plan.ctaStyle === "primary" ? "none" : `0.5px solid ${plan.popular ? "rgba(255,255,255,0.3)" : "#d0d0d0"}`,
      }}
    >
      {plan.cta}
    </Link>
  </div>
);

const FaqItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ ...s.faqItem, borderBottom: "0.5px solid #f0f0f0" }}>
      <button style={s.faqQ} onClick={() => setOpen(!open)}>
        {q}
        <span style={{ marginLeft: "auto", fontSize: 16, color: "#999", transform: open ? "rotate(45deg)" : "none", display: "inline-block", transition: "transform 0.2s", flexShrink: 0 }}>+</span>
      </button>
      {open && <div style={s.faqA}>{a}</div>}
    </div>
  );
};

/* ── page ── */
const Tarifs = () => {
  const [billingCycle, setBilling] = useState("monthly");

  return (
    <div style={s.page}>
      <style>{css}</style>
      <Header />

      {/* HERO */}
      <div style={s.hero} className="hero">
        <div style={s.heroBadge}><span style={s.badgeDot} /> Tarifs transparents, sans surprise</div>
        <h1 style={s.heroTitle}>Des prix pour <em style={{ color: "#16a34a", fontStyle: "normal" }}>tout le monde</em></h1>
        <p style={s.heroSub}>Voyagez gratuitement ou passez Premium pour une expérience améliorée.</p>
        <div style={s.toggle}>
          <button style={{ ...s.toggleBtn, ...(billingCycle === "monthly" ? s.toggleBtnActive : {}) }} onClick={() => setBilling("monthly")}>Mensuel</button>
          <button style={{ ...s.toggleBtn, ...(billingCycle === "yearly" ? s.toggleBtnActive : {}) }} onClick={() => setBilling("yearly")}>
            Annuel <span style={{ fontSize: 10, background: "#f0fdf4", color: "#16a34a", padding: "1px 6px", borderRadius: 10, marginLeft: 4 }}>−20%</span>
          </button>
        </div>
      </div>

      {/* PLANS */}
      <div style={s.plansGrid} className="plans-grid">
        {PLANS.map(plan => <PlanCard key={plan.id} plan={
          billingCycle === "yearly" && plan.price !== "Gratuit" && plan.price !== "Sur devis"
            ? { ...plan, price: String(Math.round(parseInt(plan.price.replace(" ", "")) * 12 * 0.8 / 1000) + " 000"), priceNote: "MGA / an" }
            : plan
        } />)}
      </div>

      {/* FARE TABLE */}
      <div style={s.fareSection} className="fare-section">
        <div style={s.sectionContainer}>
          <div style={s.sectionTag}>Grille tarifaire</div>
          <h2 style={s.sectionTitle}>Tarifs par trajet</h2>
          <p style={s.sectionSub}>Prix indicatifs en MGA par personne, sans frais de service.</p>
          <div style={s.tableWrap}>
            <table style={s.table}>
              <thead>
                <tr>
                  <th style={s.th}>Trajet</th>
                  <th style={{ ...s.th, color: "#999" }} className="hide-mobile">Dist.</th>
                  <th style={{ ...s.th, color: "#16a34a" }}>Bus</th>
                  <th style={{ ...s.th, color: "#3b82f6" }} className="hide-mobile">Taxi-br.</th>
                  <th style={{ ...s.th, color: "#9333ea" }}>Covoit.</th>
                </tr>
              </thead>
              <tbody>
                {FARE_TABLE.map((row, i) => (
                  <tr key={i} style={{ background: i % 2 === 0 ? "white" : "#fafaf8" }}>
                    <td style={s.td}><span style={{ fontWeight: 500 }}>{row.route}</span></td>
                    <td style={{ ...s.td, color: "#999", fontFamily: "'DM Mono',monospace", fontSize: 12 }} className="hide-mobile">{row.km} km</td>
                    <td style={{ ...s.td, fontFamily: "'DM Mono',monospace", fontWeight: 600 }}>{row.bus}</td>
                    <td style={{ ...s.td, fontFamily: "'DM Mono',monospace", fontWeight: 600 }} className="hide-mobile">{row.taxib}</td>
                    <td style={{ ...s.td, fontFamily: "'DM Mono',monospace", fontWeight: 600, color: "#9333ea" }}>{row.cov}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p style={{ fontSize: 11, color: "#bbb", marginTop: 12 }}>* Tarifs indicatifs. Les prix réels peuvent varier selon la saison et la disponibilité.</p>
        </div>
      </div>

      {/* REDUCTIONS BAND */}
      <div style={s.reductionBand} className="reduction-band">
        <div style={s.sectionContainer}>
          <div style={s.sectionTag}>Réductions</div>
          <h2 style={{ ...s.sectionTitle, color: "white" }}>Voyagez moins cher</h2>
          <div style={s.reductionGrid} className="reduction-grid">
            {[
              { label: "Enfants −5 ans",    discount: "−50%", desc: "Gratuit sur les genoux d'un adulte." },
              { label: "Enfants 5–12 ans",  discount: "−25%", desc: "Sur présentation de l'acte de naissance." },
              { label: "Groupes 5+ pers.",  discount: "−15%", desc: "Réduction automatique à la réservation." },
              { label: "Membres Premium",   discount: "−10%", desc: "Sur tous les trajets, en permanence." },
            ].map(r => (
              <div key={r.label} style={s.reductionCard}>
                <div style={s.reductionDiscount}>{r.discount}</div>
                <div style={s.reductionLabel}>{r.label}</div>
                <div style={s.reductionDesc}>{r.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div style={s.faqSection} className="faq-section">
        <div style={s.sectionContainer}>
          <div style={s.sectionTag}>Questions fréquentes</div>
          <h2 style={s.sectionTitle}>Tout ce que vous devez savoir</h2>
          <div style={{ maxWidth: 640, margin: "0 auto" }}>
            {FAQS.map(f => <FaqItem key={f.q} q={f.q} a={f.a} />)}
          </div>
        </div>
      </div>

      <footer style={s.footer} className="footer">
        <div style={{ fontSize: 13, color: "#999" }}>© 2025 TransTigo · Madagascar</div>
        <div style={{ display: "flex", gap: 20 }}>
          {["Confidentialité", "Conditions", "Contact"].map(l => (
            <Link key={l} to={`/${l.toLowerCase()}`} style={{ fontSize: 12, color: "#bbb", textDecoration: "none" }}>{l}</Link>
          ))}
        </div>
      </footer>
    </div>
  );
};

const s = {
  page:           { fontFamily: "'Plus Jakarta Sans',sans-serif", background: "#fafaf8", color: "#1a1a1a", minHeight: "100vh" },
  header:         { position: "sticky", top: 0, zIndex: 100, background: "rgba(250,250,248,0.92)", backdropFilter: "blur(12px)", borderBottom: "0.5px solid rgba(0,0,0,0.07)", padding: "0 48px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 60, flexWrap: "wrap" },
  logo:           { fontSize: 18, fontWeight: 700, letterSpacing: -0.5, color: "#1a1a1a", textDecoration: "none" },
  nav:            { display: "flex", alignItems: "center", gap: 28 },
  navLink:        { fontSize: 13.5, color: "#666", textDecoration: "none" },
  btnGhost:       { fontSize: 13, padding: "7px 16px", background: "none", border: "0.5px solid #d0d0d0", borderRadius: 8, cursor: "pointer", fontFamily: "inherit", color: "#444", textDecoration: "none" },
  btnPrimary:     { fontSize: 13, padding: "7px 16px", background: "#1a1a1a", color: "white", border: "none", borderRadius: 8, fontFamily: "inherit", fontWeight: 500, textDecoration: "none" },

  hamburger:      { display: "none", flexDirection: "column", gap: 5, background: "none", border: "none", cursor: "pointer", padding: 4 },
  hamburgerBar:   { display: "block", width: 22, height: 2, background: "#1a1a1a", borderRadius: 2, transition: "all 0.2s" },
  mobileMenu:     { width: "100%", background: "rgba(250,250,248,0.98)", borderTop: "0.5px solid #e8e8e4", display: "flex", flexDirection: "column", padding: "12px 0 8px" },
  mobileNavLink:  { fontSize: 15, fontWeight: 500, color: "#1a1a1a", textDecoration: "none", padding: "12px 0", borderBottom: "0.5px solid #f0f0f0" },

  hero:           { padding: "64px 48px 48px", textAlign: "center" },
  heroBadge:      { display: "inline-flex", alignItems: "center", gap: 6, background: "#f0fdf4", border: "0.5px solid #bbf7d0", padding: "5px 14px", borderRadius: 20, fontSize: 12, color: "#16a34a", fontWeight: 500, marginBottom: 20 },
  badgeDot:       { width: 6, height: 6, background: "#16a34a", borderRadius: "50%", display: "inline-block" },
  heroTitle:      { fontSize: 44, fontWeight: 700, letterSpacing: -1.5, marginBottom: 14, lineHeight: 1.1 },
  heroSub:        { fontSize: 15, color: "#666", lineHeight: 1.7, marginBottom: 32 },
  toggle:         { display: "inline-flex", background: "white", border: "0.5px solid #e0e0e0", borderRadius: 10, padding: 4, gap: 4 },
  toggleBtn:      { fontSize: 13, padding: "8px 20px", borderRadius: 7, border: "none", background: "none", cursor: "pointer", fontFamily: "inherit", color: "#666", display: "flex", alignItems: "center" },
  toggleBtnActive:{ background: "#1a1a1a", color: "white" },

  plansGrid:      { maxWidth: 1100, margin: "0 auto", padding: "0 48px 64px", display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 18, alignItems: "start" },
  planCard:       { borderRadius: 16, padding: 28, display: "flex", flexDirection: "column", gap: 0, position: "relative", overflow: "hidden" },
  popularBadge:   { position: "absolute", top: 16, right: 16, fontSize: 10, fontWeight: 700, padding: "4px 10px", borderRadius: 20, letterSpacing: 0.3 },
  planHeader:     { marginBottom: 24 },
  planName:       { fontSize: 13, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, marginBottom: 12 },
  planPriceRow:   { display: "flex", alignItems: "baseline", gap: 6 },
  planPrice:      { fontSize: 32, fontWeight: 700, letterSpacing: -1, fontFamily: "'DM Mono',monospace" },
  planPriceNote:  { fontSize: 12 },
  featureList:    { display: "flex", flexDirection: "column", gap: 10, marginBottom: 28 },
  featureRow:     { display: "flex", alignItems: "flex-start", gap: 10 },
  planCta:        { display: "block", textAlign: "center", padding: "12px 0", borderRadius: 10, fontSize: 13, fontWeight: 600, textDecoration: "none", marginTop: "auto" },

  fareSection:    { background: "white", padding: "64px 48px" },
  sectionContainer:{ maxWidth: 1100, margin: "0 auto" },
  sectionTag:     { fontSize: 11, textTransform: "uppercase", letterSpacing: 1, color: "#999", fontWeight: 600, marginBottom: 8 },
  sectionTitle:   { fontSize: 28, fontWeight: 700, letterSpacing: -0.8, marginBottom: 8 },
  sectionSub:     { fontSize: 14, color: "#666", marginBottom: 28 },
  tableWrap:      { overflowX: "auto", border: "0.5px solid #e8e8e4", borderRadius: 12, overflow: "hidden" },
  table:          { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  th:             { padding: "12px 16px", background: "#f4f4f0", textAlign: "left", fontWeight: 600, fontSize: 11, textTransform: "uppercase", letterSpacing: 0.5, color: "#666", borderBottom: "0.5px solid #e8e8e4" },
  td:             { padding: "12px 16px", borderBottom: "0.5px solid #f4f4f0", fontSize: 13 },

  reductionBand:  { background: "#1a1a1a", padding: "64px 48px" },
  reductionGrid:  { display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 16, marginTop: 32 },
  reductionCard:  { background: "rgba(255,255,255,0.05)", border: "0.5px solid rgba(255,255,255,0.08)", borderRadius: 12, padding: 20 },
  reductionDiscount:{ fontSize: 28, fontWeight: 700, color: "#4ade80", letterSpacing: -1, marginBottom: 6 },
  reductionLabel: { fontSize: 13, fontWeight: 600, color: "white", marginBottom: 6 },
  reductionDesc:  { fontSize: 12, color: "rgba(255,255,255,0.4)", lineHeight: 1.6 },

  faqSection:     { padding: "64px 48px", background: "#fafaf8" },
  faqItem:        { padding: "4px 0" },
  faqQ:           { width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 0", background: "none", border: "none", fontSize: 14, fontWeight: 600, color: "#1a1a1a", cursor: "pointer", fontFamily: "inherit", textAlign: "left", gap: 12 },
  faqA:           { fontSize: 13, color: "#666", lineHeight: 1.7, paddingBottom: 16 },

  footer:         { padding: "24px 48px", borderTop: "0.5px solid #e8e8e4", display: "flex", alignItems: "center", justifyContent: "space-between", background: "white" },
};

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap');

  /* ── Tablet (≤ 900px) ── */
  @media (max-width: 900px) {
    .desktop-nav { display: none !important; }
    .hamburger   { display: flex !important; }

    header { padding: 0 20px !important; height: auto !important; min-height: 60px; }

    .hero { padding: 48px 24px 40px !important; }
    .hero h1 { font-size: 32px !important; letter-spacing: -1px !important; }

    .plans-grid {
      grid-template-columns: 1fr !important;
      padding: 0 24px 48px !important;
      max-width: 480px !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }

    .fare-section   { padding: 48px 20px !important; }
    .reduction-band { padding: 48px 20px !important; }
    .faq-section    { padding: 48px 20px !important; }

    .reduction-grid {
      grid-template-columns: repeat(2, 1fr) !important;
    }

    .footer {
      flex-direction: column !important;
      gap: 12px !important;
      padding: 20px 24px !important;
      text-align: center;
    }
  }

  /* ── Mobile (≤ 540px) ── */
  @media (max-width: 540px) {
    .hero h1 { font-size: 26px !important; }
    .hero p  { font-size: 14px !important; }

    .plans-grid { padding: 0 16px 40px !important; }

    .hide-mobile { display: none !important; }

    .reduction-grid {
      grid-template-columns: 1fr 1fr !important;
      gap: 10px !important;
    }

    .fare-section  { padding: 40px 16px !important; }
    .faq-section   { padding: 40px 16px !important; }
  }
`;

export default Tarifs;